module.exports = "<p>\r\n  creditbureaudetails works!\r\n</p>\r\n"